import React from "react"
import {Grid, Stack} from "@mui/material";
import {formatTime} from "@/helper/method";
import {GridItem} from "@/widget/GridItem/GridItem";
import {ResultWrapper} from "@/widget/ResultWrapper/ResultWrapper";
import isEmpty from "lodash/isEmpty";
import {useQueryWorktime, WorktimeVO} from "@/service/worktime.s";
import Typography from "@mui/material/Typography";
import {reviewStatus} from "@/helper/constant";
import {isNumber} from "lodash";
import {useDrawerModal} from "@/store/global.c";

export const ViewWorktime = () => {
    const {id} = useDrawerModal()
    const {data: worktimeData, isLoading: worktimeLoading} = useQueryWorktime({id: id!}, isNumber(id))
    const worktime = worktimeData?.data || {} as WorktimeVO
    const {task, plan, review, ...rest} = worktime

    return <ResultWrapper isLoading={worktimeLoading} isEmpty={isEmpty(worktime)}>
        <Stack direction="column" gap={1.5}>
            <Typography variant={"h6"} fontSize={16} fontWeight={500}>工时登记</Typography>
            <Grid
                spacing={3}
                container
            >
                <GridItem title={'目标计划'} content={plan?.planName}/>
                <GridItem title={'所属任务'} content={task?.taskName}/>
                <GridItem title={'预计工时'} content={task?.duration}/>
                <GridItem title={'工作时长'} content={rest?.hours}/>
                <GridItem title={'工作执行人'} content={rest?.creator}/>
                <GridItem title={'当前负责人'} content={plan?.executor}/>
                <GridItem title={'创建时间'} content={formatTime("D", rest?.createdAt)}/>
                <GridItem title={'更新时间'} content={formatTime("D", rest?.updatedAt)}/>
                <GridItem minHeight={'80px'} size={12} title={'工时描述'} content={rest?.description || '-'}/>
            </Grid>
            <Typography variant={"h6"} fontSize={16} fontWeight={500}>工时审核</Typography>
            <Grid
                spacing={3}
                container
            >
                <GridItem title={'审核结果'} content={reviewStatus[review?.status]}/>
                <GridItem title={'审核时间'} content={review?.reviewAt && formatTime("D", review?.reviewAt) || '-'}/>
                <GridItem minHeight={'80px'} size={12} title={'审核意见'} content={review?.opinion || '-'}/>
            </Grid>
        </Stack>
    </ResultWrapper>
};
